import { lazy, Suspense } from "react";
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";

// 페이지 lazy loading - 초기 번들 크기 최소화
const Home = lazy(() => import("../pages/home/page"));
const ProductDetail = lazy(() => import("../pages/product/page"));
const About = lazy(() => import("../pages/about/page"));
const SearchPage = lazy(() => import("../pages/search/page"));
const AdminPage = lazy(() => import("../pages/admin/page"));
const PartnerPage = lazy(() => import("../pages/partner/page"));

const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-white">
    <div className="w-6 h-6 border-2 border-gray-300 border-t-gray-700 rounded-full animate-spin"></div>
  </div>
);

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Suspense fallback={<PageLoader />}><Home /></Suspense>,
  },
  {
    path: "/product/:id",
    element: <Suspense fallback={<PageLoader />}><ProductDetail /></Suspense>,
  },
  {
    path: "/about",
    element: <Suspense fallback={<PageLoader />}><About /></Suspense>,
  },
  {
    path: "/search",
    element: <Suspense fallback={<PageLoader />}><SearchPage /></Suspense>,
  },
  {
    path: "/admin",
    element: <Suspense fallback={<PageLoader />}><AdminPage /></Suspense>,
  },
  {
    path: "/partner",
    element: <Suspense fallback={<PageLoader />}><PartnerPage /></Suspense>,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
